import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "saved-agents",
  "aria-label": "Saved agents"
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item-actions" }
const _hoisted_5 = {
  key: 1,
  class: "empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_Icon = _resolveComponent("Icon")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Ellipsis, { class: "title" }, {
        default: _withCtx(() => [
          _createTextVNode("Saved agents (" + _toDisplayString($props.agents.length) + "/" + _toDisplayString($data.max_agents) + ")", 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Autosave, {
        saving: $props.saving,
        saved_at: $props.saved_at,
        class: "autosave"
      }, null, 8 /* PROPS */, ["saving", "saved_at"])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "description" }, "Review, edit, or delete your test agents", -1 /* HOISTED */)),
    ($props.agents.length)
      ? (_openBlock(), _createBlock(_component_ScrollBar, {
          key: 0,
          class: "scrollbar",
          fade: "",
          "bar-x-offset": "0.4rem"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CollapseGroup, {
              items: $props.agents,
              duration: 300,
              gap: "0.8rem"
            }, {
              default: _withCtx(({item, index}) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["agent-item", {selected: index === $props.editing_idx, pointer: index !== $props.editing_idx}]),
                  onClick: $event => (_ctx.$emit('edit', item, index))
                }, [
                  _createVNode(_component_Icon, {
                    icon: "scroll-text",
                    class: "agent-icon",
                    size: "2rem",
                    stroke: "var(--gray-700)",
                    "stroke-width": "1"
                  }),
                  _createVNode(_component_Ellipsis, { class: "text" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_IconAsButton, {
                      icon: "edit-03",
                      color: "--gray-600",
                      tooltip: "Edit agent"
                    }),
                    _createVNode(_component_Popconfirm, {
                      width: "max-content",
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      title: "Are you sure you want to delete this agent?",
                      onConfirm: $event => (_ctx.$emit('delete', index))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconAsButton, {
                          icon: "trash-04",
                          color: "--gray-600",
                          tooltip: "Delete agent",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                        })
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_3)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items"])
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, "No saved agents yet"))
  ]))
}